import { Route } from 'react-router-dom';

import { ReservationSummaryPage } from './pages/reservation-summary-page.js';

/**
 * The Reservation Summary module's routes.
 *
 * A single dashboard at /reservation-summary that aggregates reservations by
 * property and gives an at-a-glance view of bookings for the selected period.
 */
export function reservationSummaryRoutes(): React.JSX.Element {
  return <Route path="/reservation-summary" element={<ReservationSummaryPage />} />;
}
